require('./policyBackupWindowDialog.style.scss');
const { permissions } = require('../../../../constants/permissions');
const BackupWindow = require('../../../../model/BackupWindow');

const HELP_SPECIFY = 'backup-window',
    HELP_CREATE = 'backup-window';

class PgBackupWindowDialogController {
    constructor($scope, $filter, $element, policiesPersistence, dialogService, notificationService, contentSwitcherService, utilsService, iamPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$element = $element;
        this.persistence = policiesPersistence;
        this.dialogService = dialogService;
        this.notificationService = notificationService;
        this.iamPersistenceService = iamPersistenceService;
        this.contentSwitcherService = contentSwitcherService;
        this.utilsService = utilsService;
        this.mainTitle = this.$filter('translate')('policy.backupWindow.title');
        this.modalTitle = this.mainTitle;
        this.modalSubTitle = null;
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === "function";
        this.configBackupWindowTable();
        this.selectedBackupWindows = [];
        this.CREATE_STATE = 'create';
        this.EDIT_STATE = 'edit';
        this.MAIN_STATE = 'main';
        this.defaultPageSize = 100;
        this.tzChanged = false;
        this.isFirstEditLoad = false;
    }

    $onInit() {
        this.tzDiffMessage = null;
        this.closeId = { close: 'policies-backup-window-close', closeIcon: 'policies-backup-window-close-icon' };

        if (this.animateSwitcher && !this.minInnerHeight) {
            this.minInnerHeight = this.getMinHeight();
        }

        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => { this.onBackAction(); },
                isVisible: () => this.state !== this.MAIN_STATE,
                btnClass: 'ctx-btn-secondary',
                id: 'policies-backup-window-back'
            },
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: () => { this.saveBackupWindow(); },
                // disabled when backupWindowSpecifics is empty (reason: backend create/update fail when list is empty)
                isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.disableSaveButton(),
                isVisible: () => this.state !== this.MAIN_STATE,
                id: 'policies-backup-window-save'
            }
        ];
        this.$scope.$watch(() => this.selectedTimeZone, (newSelectedTz, oldSelectedTz) => {
            if (!newSelectedTz || !oldSelectedTz) return;
            if ((newSelectedTz.value - oldSelectedTz.value) !== 0) {
                if (!this.isFirstEditLoad) {
                    this.selectedHours = this.calculateTimeZone(this.selectedHours, newSelectedTz.value - oldSelectedTz.value);
                } else {
                    this.selectedHours = this.calculateTimeZone(this.selectedHours, 0);

                }
                this.tzChanged = !this.tzChanged;
            }
        });
        this.bwSearch = {};
    }

    configBackupWindowTable() {
        this.bwTableConfig = [
            this.$filter('translate')('policy.backupWindow.table.header.name'),
            this.$filter('translate')('policy.backupWindow.table.header.description')
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('51%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('49%');

        this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
        this.gridFlag = true;
    }



    setTimezonesDropdown() {
        const tmz = moment.tz.guess();
        this.allTimezones = this.utilsService.getAllTimezones();
        this.offsetTmz = this.allTimezones;
        const localOffset = this.utilsService.getLocalUTCOffset();
        this.selectedTimeZone = this.allTimezones.find(t => t.name === tmz);
        this.localTimeZone = this.selectedTimeZone;
    }


    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === this.MAIN_STATE) {
            this.helpId = HELP_SPECIFY;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.selectedHours = [];
        }
        else {
            this.helpId = HELP_CREATE;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = (' » ') + (state === this.CREATE_STATE ? this.$filter('translate')('policy.backupWindow.new.title') : this.$filter('translate')('policy.backupWindow.edit.title') + ' ' + this.backupWindow.name);
        }
        this.state = state;
    }

    newBackupScheduler() {
        this.backupWindow = this.persistence.newBackupWindow();
        this.selectedTimeZone = this.localTimeZone;
        this.changeState(this.CREATE_STATE);
    }

    editBackupScheduler() {
        if (!this.selectedBackupWindows[0]) return;
        return this.persistence.getBackupWindow(this.selectedBackupWindows[0].uuid, true).then(bkw => {
            this.isFirstEditLoad = true;
            this.selectedTimeZone = this.allTimezones.filter(otz => otz.name === bkw.timezone.name)[0];
            this.backupWindow = bkw;
            this.selectedHours = this.backupWindow.backupWindowSpecifics;
            this.changeState(this.EDIT_STATE);
        }, err => { });
    }

    deleteBackupScheduler() {
        return this.deleteBackupWindow(this.selectedBackupWindows[0]);
    }

    onOpen() {
        this.helpId = HELP_SPECIFY;
        this.state = this.MAIN_STATE;
        this.load();
    }

    onBackAction() {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.onCloseModal();
            });
        } else {
            this.onCloseModal();
        }
    }

    onCloseModal() {
        this.selectedHours = [];
        if (this.state !== this.MAIN_STATE) {
            this.state = this.MAIN_STATE;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.helpId = HELP_SPECIFY;
            return { preventDefault: true };
        }
        this.selectedBackupWindows = [];
        this.state = this.MAIN_STATE;
        this.onClose({ success: true });
        this.showModal = false;
        this.policy = null;
    }

    onTitleClick() {
        this.changeState(this.MAIN_STATE);
    }

    saveBackupWindow() {
        // new 'offset' property => moment.parseZone(moment().valueOf()).utcOffset()/60
        // console.log('TEST', moment.parseZone(moment().valueOf()).utcOffset()/60)
        this.backupWindow.backupWindowSpecifics = this.selectedHours;
        this.backupWindow.timezone = {
            name: this.selectedTimeZone.name,
            offset: this.selectedTimeZone.label.match(/\(([^)]+)\)/)[1]
        };

        this.persistence[this.state === this.CREATE_STATE ? 'createBackupWindow' : 'updateBackupWindow'](this.backupWindow, this.currentBkwName).then(res => {
            this.reload = this.reload || (this.state === this.EDIT_STATE);
            this.switcherOnChange = true;
            (this.state === this.CREATE_STATE) ? this.reloadOnSave(true, this.backupWindow) : this.load(false, false, null);
            this.notificationService.pop(res.data.message);
        }, err => {
        }).finally(() => {
            this.changeState(this.MAIN_STATE);
            this.selectedTimeZone = null;
            this.selectedHours = [];
        });
    }

    load(firstPage, animate, bw) {
        // this.persistence.getManagerTimezone().then(res => {
        //     if (!res) return;
        // this.bkpCtrl_zone = { timezoneName: "Europe/Ljubljana", timezoneOffset: 120 };
        this.bkpCtrl_zone = { timezoneName: "UTC", timezoneOffset: 0 };
        this.setTimezonesDropdown();
        // });

        return this.persistence.getBackupWindows(firstPage).then(
            bkpWins => {
                let selectedItem;
                this.backupWindowItems = bkpWins;
                if (this.animateSwitcher && animate && !this.switcherOnChange) {
                    this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                        this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                        this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                    });
                }
                if (bw) {
                    selectedItem = this.backupWindowItems.filter(item => item.name === bw.name)[0];
                    if (selectedItem) this.selectedBackupWindows = [selectedItem];
                }
                this.switcherOnChange = false;
                return { page: this.persistence.bkWinTableState ? this.persistence.bkWinTableState.page : 1, selected: selectedItem, length: this.backupWindowItems.length };
            }
        );
    }

    reloadOnSave(firstPage, item) {
        if (!firstPage) this.persistence.bkWinTableState.page++;
        else this.persistence.bkWinTableState.searchBy = undefined;

        this.switcherOnChange = true;
        this.load(firstPage, false, item).then(res => {
            if (!res.length) return;
            if (!res.selected) {
                this.reloadOnSave(false, this.backupWindow);
            }
        });
    }

    deleteBackupWindow(bkWin) {
        this.persistence.checkForPolicy('backupWindows', bkWin).then(res => {
            if (res.length === 0) {
                this.dialogService.showYesNo(this.$filter('translate')('policy.backupWindow.deleteDialogNoAssigned.text'),
                    this.$filter('translate')('policy.backupWindow.deleteDialog.title'), null, 'delete-backup-window')
                    .then(result => {
                        if (result) {
                            this.reload = true;
                            return this.persistence.deleteBackupWindow(bkWin);
                        }
                    })
                    .then(res => {
                        if (res) {
                            this.afterDeletionAction(res);
                        }
                    }, err => { });
            } else {
                this.dialogService.showYesNo(this.$filter('translate')('policy.backupWindow.deleteDialog.text', { name: bkWin.name, policies: res.toString().replace(/,/g, ", ") }),
                    this.$filter('translate')('policy.backupWindow.deleteDialog.title'), null, 'delete-backup-window')
                    .then(result => {
                        if (result) {
                            this.reload = true;
                            return this.persistence.deleteBackupWindow(bkWin);
                        }
                    })
                    .then(res => {
                        if (res) {
                            this.afterDeletionAction(res);
                        }
                    }, err => { });

            }
        });
    }

    afterDeletionAction(res) {
        this.notificationService.pop(res.data.message);
        this.selectedBackupWindows = [];
        this.load(null, true);
    }

    getMinHeight() {
        let modalBody = this.$element.find('.modal-body'), minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight ? (parseFloat(minHeight) - parseFloat(modalBody.css('padding-top')) - parseFloat(modalBody.css('padding-bottom'))) : null;
    }

    convertToHourMinutes(minutes) {
        let h = Math.floor(minutes / 60), m = minutes % 60;
        return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    }

    sortTable() {
        this.load();
    }

    calculateTimeZone(updatedHours, tzDiff) {
        if (updatedHours && updatedHours.length > 0) {
            let days = [{ value: 'MONDAY' }, { value: 'TUESDAY' }, { value: 'WEDNESDAY' }, { value: 'THURSDAY' }, { value: 'FRIDAY' }, { value: 'SATURDAY' }, { value: 'SUNDAY' }],
                daySorter = {};
            days.forEach((day, index) => {
                daySorter[day.value.toUpperCase()] = index;
            });
            for (let i = 0; i < updatedHours.length; i++) {
                let sh = updatedHours[i];
                let oldSh = JSON.parse(JSON.stringify(sh));
                if (!sh.pushed) {
                    let indexOfCurrentDay = days.map((day) => day.value).indexOf(sh.dayOfWeek),
                        indexOfNextDay = (indexOfCurrentDay + Math.floor((sh.windowStartTime + tzDiff) / 2879) + 1) % 7,
                        indexOfPrevDay = (7 + indexOfCurrentDay - 1 - ((sh.windowEndTime <= Math.abs(tzDiff) - 1440) ? 1 : 0)) % 7,
                        howManyDays = Math.floor(Math.abs(tzDiff) / 1441) + 1;

                    if (sh.windowStartTime + tzDiff >= 1440) {
                        sh.dayOfWeek = days[indexOfNextDay].value;
                    } else if (sh.windowEndTime + tzDiff <= 0) {
                        sh.dayOfWeek = days[indexOfPrevDay].value;
                    }
                    sh.incrementalWindowSpecific = oldSh.incrementalWindowSpecific;

                    sh.windowStartTime = (1440 * howManyDays + sh.windowStartTime + tzDiff) % 1440;
                    sh.windowEndTime = (1440 * howManyDays + sh.windowEndTime + tzDiff) % 1440;
                    if (sh.windowEndTime === 0) sh.windowEndTime = 1440;

                    if (sh.windowStartTime >= sh.windowEndTime) {
                        sh.windowEndTime = tzDiff > 0 ? 1440 : sh.windowEndTime;
                        sh.windowStartTime = tzDiff < 0 ? 0 : sh.windowStartTime;
                        let day = (tzDiff > 0 ? indexOfNextDay : indexOfPrevDay) + (tzDiff >= 1440 ? 1 : tzDiff <= -1440 ? -1 : 0);
                        updatedHours.push({
                            dayOfWeek: days[day].value,
                            windowStartTime: tzDiff > 0 ? 0 : (1440 * howManyDays + oldSh.windowStartTime + tzDiff) % 1440,
                            windowEndTime: tzDiff > 0 ? (oldSh.windowEndTime + tzDiff) % 1440 : 1440,
                            incrementalWindowSpecific: oldSh.incrementalWindowSpecific,
                            pushed: true
                        });
                    }
                }
            }
            updatedHours = updatedHours.sort((a, b) => {
                return a.dayOfWeek !== b.dayOfWeek ?
                    daySorter[a.dayOfWeek.toUpperCase()] - daySorter[b.dayOfWeek.toUpperCase()] :
                    a.windowStartTime - b.windowStartTime;
            });
            for (let i = 0; i < updatedHours.length; i++) {
                if (updatedHours[i].pushed) delete updatedHours[i].pushed;
                if (updatedHours[i + 1] && updatedHours[i].dayOfWeek === updatedHours[i + 1].dayOfWeek && updatedHours[i].windowEndTime === updatedHours[i + 1].windowStartTime && updatedHours[i].incrementalWindowSpecific === updatedHours[i + 1].incrementalWindowSpecific) {
                    updatedHours[i].windowEndTime = updatedHours[i + 1].windowEndTime;
                    updatedHours.splice(i + 1, 1);
                }
            }
            this.isFirstEditLoad = false;
            return updatedHours;
        } else {
            return [];
        }
    }

    searchTimezone() {
        this.offsetTmz = this.allTimezones.filter(tz => tz.label.toLowerCase().indexOf(this.bwSearch.searchBy.toLowerCase()) !== -1);
    }

    disableSaveButton() {
        let condition;
        if (!this.selectedHours || this.selectedHours.length === 0) {
            condition = true;
        } else {
            let incrementalWindows = this.selectedHours.reduce((acc, record) => {
                if (record.incrementalWindowSpecific) acc.push(record.incrementalWindowSpecific);
                return acc;
            }, []);
            condition = incrementalWindows.length === this.selectedHours.length;
        }
        return condition;
    }

    setTimeZone(timezone) {
        if (timezone.name !== this.selectedTimeZone.name) {
            this.selectedTimeZone = this.allTimezones.filter(otz => otz.name === timezone.name)[0];
        }
    }

    isCreateBWDisabled() {
        return !this.hasCreateBWPermissions();
    }

    isUpdateBWDisabled() {
        return !this.hasEditBWPermissions() || !this.selectedBackupWindows || !this.selectedBackupWindows.length || this.selectedBackupWindows.length === 0;
    }

    isDeleteBWDisabled() {
        return !this.hasDeleteBWPermissions() || !this.selectedBackupWindows || !this.selectedBackupWindows.length || this.selectedBackupWindows.length === 0;
    }

    hasBWListPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.BW_LISTING);
    }

    hasCreateBWPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.BW_CREATE);
    }

    hasEditBWPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.BW_UPDATE);
    }

    hasDeleteBWPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.BW_DELETE);
    }

}

PgBackupWindowDialogController.$inject = ['$scope', '$filter', '$element', 'policiesPersistence', 'dialogService', 'notificationService', 'contentSwitcherService', 'utilsService', 'iamPersistenceService'];

const pgBackupWindowDialogComponent = {
    controller: PgBackupWindowDialogController,
    require: {
    },
    template: require('./policyBackupWindowDialog.template.html'),
    bindings: {
        showModal: '=',
        onClose: '&'
    }
};

module.exports = pgBackupWindowDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/policies/dialogs/policyBackupWindowDialog/policyBackupWindowDialog.component.js